<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-4 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-8 text-right">
          <div class="box-buttons">
            <base-dropdown
              menu-on-right
              class="nav-item"
              tag="li"
              title-tag="a"
              title-classes="btn min-button btn-outline-neutral mr-2"
              title="Actions"
            >
              <base-button slot="title" type="none" class="p-0 min-button">
                <i class="flaticon-send"></i>
                <strong class="d-lg-block d-none">Send Email</strong>
              </base-button>

              <div
                class="dropdown-item"
                @click="sendEmailToConfirmAccount(operatorId)"
              >
                To confirm Account
              </div>
              <div
                class="dropdown-item"
                @click="sendEmailToRecoverPassword(operatorId)"
              >
                To password recover
              </div>
            </base-dropdown>

            <base-button
              type="outline-neutral"
              @click="mode = 'view'"
              class="min-button mr-2 no-mb"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-view-1 icon-no-margin"></i>
              <strong class="d-lg-block d-none">View</strong>
            </base-button>

            <base-button
              type="outline-neutral"
              @click="mode = 'edit'"
              class="min-button mr-2 no-mb"
              v-if="mode === 'view' && canUserUpdate"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              type="primary"
              class="min-button no-mb"
              v-if="mode === 'edit' && canUserUpdate"
              @click="saveOperator()"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid profile mb-5 forms">
      <div class="row">
        <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row">
            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card">
                <div class="row justify-content-center">
                  <div class="col-lg-12 col-md-12 text-center">
                    <div class="d-inline-block mt-2 mb-3">
                      <div
                        class="badge-profile status-confirmed"
                        v-if="
                          operator.authentication.accountStatus === 'ACTIVE'
                        "
                      >
                        <i
                          class="flaticon-bold-check-3 text-success f25 mr-2"
                        ></i>
                        <span>Active</span>
                      </div>

                      <div class="badge-profile status-cancelled " v-else>
                        <i
                          class="flaticon-bold-cancel text-danger f25 mr-2"
                        ></i>
                        <span>Inactive</span>
                      </div>
                    </div>

                    <label
                      for="driver_ProfileImage"
                      class="title-label-np mb-2"
                      v-if="mode === 'edit'"
                    >
                      Profile Image
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <ul class="ul-pop">
                          <li>Allowed Dimensions: 500px x 500px</li>
                          <li>Maximum Size: 2MB</li>
                          <li>Allowed Formats: gif, jpg, jpeg, png</li>
                        </ul>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </label>

                    <div class="imageload3">
                      <div class="image">
                        <div
                          v-if="operator.businessDetails.image"
                          v-bind:style="{
                            backgroundImage:
                              'url(' + operator.businessDetails.image + ')'
                          }"
                          class="imgprofile"
                        ></div>

                        <div
                          v-else
                          v-bind:style="{
                            backgroundImage: 'url(' + imageProfile + ')'
                          }"
                          class="imgprofile"
                        ></div>
                      </div>

                      <div class="contentfile3" v-if="mode === 'edit'">
                        <base-dropdown>
                          <base-button
                            slot="title-container"
                            type="primary"
                            class="dropdown-toggle btn-icon-only buttonfiles3"
                          >
                            <i class="flaticon-camera mr-0"></i>
                          </base-button>
                          <span class="dropdown-item">
                            <base-input
                              class="filebutton3"
                              type="file"
                              name="file-1"
                              id="file-1"
                              :accesskey="'profile'"
                              enctype="multipart/form-data"
                              accept="image/jpeg, image/jpg, image/png"
                              @change="readFile"
                            ></base-input>
                            Upload Image
                          </span>
                          <span
                            class="dropdown-item"
                            v-if="picture"
                            @click="clearfile()"
                            >Remove
                          </span>
                        </base-dropdown>
                      </div>
                    </div>
                    <div
                      class="box-profile-one d-flex align-items-center justify-content-center"
                    >
                      <h2 class="subtitle d-inline-flex mb-1">
                        {{ operator.businessDetails.name }}
                      </h2>
                      <div class="d-inline-flex ml-1 ">
                        <el-tooltip
                          v-if="operator.authentication.verified"
                          content="Account Email Confirm"
                          placement="bottom"
                        >
                          <i class="flaticon-check-2 text-success f20 mb-1"></i>
                        </el-tooltip>

                        <el-tooltip
                          v-else
                          content="Account Email Not Confirm"
                          placement="bottom"
                        >
                          <i class="flaticon-check-2 text-danger f20 mb-1"></i
                        ></el-tooltip>
                      </div>
                    </div>

                    <div class="mt-2 mb-2">
                      <div
                        class="d-inline-block"
                        v-if="operator.serviceType === 'PRODUCTS'"
                      >
                        <div class="badge-profile status-new">
                          <i
                            class="flaticon-tools-traveling text-blue f25 mr-2"
                          ></i>
                          <span>Restricted to Experiences Only</span>
                        </div>
                      </div>
                    </div>
                    <div class="mb-3">
                      <div class="d-inline-block mr-1">
                        <div
                          class="badge-profile status-confirmed"
                          v-if="operator.affiliate"
                        >
                          <i
                            class="flaticon-checkmark text-success f25 mr-2"
                          ></i>
                          <span>Affiliated</span>
                        </div>

                        <div class="badge-profile status-draft" v-else>
                          <i class="flaticon-remove text-neutral f25 mr-2"></i>
                          <span>No Affiliated</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12"
              v-if="mode === 'edit'"
            >
              <div class="card ">
                <div class="row">
                  <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <span class="">
                      Supplier Status
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <span class="mb-2 d-block">
                          <strong>- Active:</strong> The supplier can log in and
                          manage their operations (Reservations, Rates,
                          Customers, etc.).
                        </span>

                        <span class="mb-2 d-block">
                          <strong>- Inactive:</strong> The supplier cannot log
                          in.</span
                        >
                        <span>
                          <strong>Note:</strong> You cannot deactivate a
                          supplier if there are pending reservations from
                          RhomTrip associated with them.
                        </span>

                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </span>
                  </div>
                  <div
                    class="col-xl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-center"
                  >
                    <base-switch
                      v-model="operatorStatus"
                      @input="changeOperatorStatus"
                    ></base-switch>
                  </div>

                  <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <span>
                      Restrict to Experiences Only
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <span class="mb-2 d-block">
                          <strong>- Active:</strong> Enable this supplier to
                          restrict use to the experiences module only. </span
                        ><span class="mb-2 d-block">
                          <strong>- Inactive:</strong> Turn off for
                          transfer-related searches.
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </span>
                  </div>
                  <div
                    class="col-xl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-center"
                  >
                    <base-switch
                      onText="Yes"
                      offText="No"
                      v-model="serviceType"
                      @input="servicesProvided"
                    ></base-switch>
                  </div>

                  <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                    <span class="">
                      Affiliate Network
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <span class="mb-2 d-block">
                          This supplier can be selected from RhomTrip's pool of
                          suppliers for quoting. </span
                        ><span class="mb-2 d-block">
                          <strong>Note:</strong> This option is independent of
                          the supplier's active status. Even if a supplier is
                          active, their services will not be available for
                          quoting unless this option is enabled. The rates and
                          areas offered to RhomTrip are distinct from those set
                          by the supplier independently.
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </span>
                  </div>
                  <div
                    class="col-xl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-center"
                  >
                    <base-switch
                      onText="Yes"
                      offText="No"
                      v-model="operatorAffiliate"
                      @input="changeAffiliateNetwork"
                    ></base-switch>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card ">
                <h2 class="subtitle">Notes</h2>
                <div class="row">
                  <div class="col-12">
                    <div class="data-block" v-if="mode === 'view'">
                      <span class="content-block" v-if="operator.notes">{{
                        operator.notes
                      }}</span>
                      <span class="content-block" v-else>No notes here</span>
                    </div>

                    <div class="mb-4 " v-if="mode === 'edit'">
                      <el-input
                        v-model="$v.operator.notes.$model"
                        placeholder="Notes"
                        id="operator_notes"
                        name="operator_notes"
                        maxlength="500"
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 20 }"
                        show-word-limit
                      >
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-lg-12 col-md-12">
          <tabs
            tabNavClasses="tabs-home justify-content-around tab-profiles"
            :value="tabActive"
            @changeTabActive="changeTabActive"
            type="primary"
          >
            <tab-pane
              class="tabs-home-content"
              id="Overview"
              title="Overview"
              ref="Overview"
            >
              <div class="card">
                <h2 class="subtitle">
                  Business Details
                </h2>
                <div class="row mt-2" v-if="mode === 'edit'">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-model.trim="$v.operator.businessDetails.name.$model"
                      id="operator_name"
                      name="operator_name"
                      label="DBA Name "
                      placeholder="DBA Name"
                      maxlength="45"
                      markrequired
                      :error="
                        !$v.operator.businessDetails.name.minLength ||
                        $v.operator.businessDetails.name.$error
                          ? `Enter from ${$v.operator.businessDetails.name.$params.minLength.min} to ${$v.operator.businessDetails.name.$params.maxLength.max} characters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-6 col-lg-8 col-md-6 col-sm-8 col-12">
                    <base-input
                      v-model="$v.operator.businessDetails.legalName.$model"
                      id="legal_name"
                      name="legal_name"
                      label="Legal Name "
                      placeholder="Legal Name"
                      maxlength="45"
                      markrequired
                      :error="
                        !$v.operator.businessDetails.legalName.minLength ||
                        $v.operator.businessDetails.legalName.$error
                          ? `Enter from ${$v.operator.businessDetails.legalName.$params.minLength.min} to ${$v.operator.businessDetails.legalName.$params.maxLength.max} characters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-model.trim="
                        $v.operator.businessDetails.vatNumber.$model
                      "
                      label="VAT Number"
                      placeholder="VAT Number"
                      id="bussiness_VatNumber"
                      name="bussiness_VatNumber"
                      maxlength="45"
                      :error="
                        !$v.operator.businessDetails.vatNumber.minLength
                          ? `Enter from ${$v.operator.businessDetails.vatNumber.$params.minLength.min} to ${$v.operator.businessDetails.vatNumber.$params.maxLength.max} characters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-model.trim="
                        $v.operator.businessDetails.licenseNumber.$model
                      "
                      label="License Number"
                      placeholder="license Number"
                      id="bussiness_licenseNumber"
                      name="bussiness_licenseNumber"
                      tabindex="2"
                      maxlength="45"
                      :error="
                        !$v.operator.businessDetails.licenseNumber.minLength
                          ? `Enter from ${$v.operator.businessDetails.licenseNumber.$params.minLength.min} to ${$v.operator.businessDetails.licenseNumber.$params.maxLength.max} characters`
                          : ''
                      "
                    />
                  </div>
                </div>

                <div class="row" v-if="mode === 'view'">
                  <div class="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">DBA Name</span>
                      <span class="content-block">{{
                        operator.businessDetails.name
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-12"
                    v-if="operator.businessDetails.legalName"
                  >
                    <div class="data-block">
                      <span class="title-block">Legal Name</span>
                      <span class="content-block">{{
                        operator.businessDetails.legalName
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12"
                    v-if="operator.businessDetails.vatNumber"
                  >
                    <div class="data-block">
                      <span class="title-block">VAT Number</span>
                      <span class="content-block">{{
                        operator.businessDetails.vatNumber
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12"
                    v-if="operator.businessDetails.licenseNumber"
                  >
                    <div class="data-block">
                      <span class="title-block">License Number</span>
                      <span class="content-block">{{
                        operator.businessDetails.licenseNumber
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <h2 class="subtitle">
                  Main Contact
                </h2>
                <div class="row mt-2" v-if="mode === 'edit'">
                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-model.trim="$v.operator.contactPerson.firstName.$model"
                      id="operator_FirstName"
                      name="operator_FirstName"
                      label="First Name"
                      placeholder="First Name"
                      format="capitalize"
                      maxlength="45"
                      markrequired
                      :error="
                        !$v.operator.contactPerson.firstName.minLength ||
                        $v.operator.contactPerson.firstName.$error
                          ? `Enter from ${$v.operator.contactPerson.firstName.$params.minLength.min} to ${$v.operator.contactPerson.firstName.$params.maxLength.max} letters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-model.trim="$v.operator.contactPerson.lastName.$model"
                      id="operator_LastName"
                      name="operator_LastName"
                      label="Last Name"
                      placeholder="Last Name"
                      format="capitalize"
                      maxlength="45"
                      markrequired
                      :error="
                        !$v.operator.contactPerson.lastName.minLength ||
                        $v.operator.contactPerson.lastName.$error
                          ? `Enter from ${$v.operator.contactPerson.lastName.$params.minLength.min} to ${$v.operator.contactPerson.lastName.$params.maxLength.max} letters`
                          : ''
                      "
                    />
                  </div>
                  <div
                    class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12 form-group"
                    v-bind:class="{
                      'is-invalid': $v.operator.contactPerson.gender.$error
                    }"
                  >
                    <label for="title" class="title-label">Gender</label>
                    <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                      <b-form-radio-group
                        v-model="$v.operator.contactPerson.gender.$model"
                        :aria-describedby="ariaDescribedby"
                        id="radio-gender"
                        name="radio-gender"
                        buttons
                        button-variant="outline-neutral"
                        size="md"
                        tabindex="3"
                      >
                        <b-form-radio value="male" class="pc-4" tabindex="3"
                          >Mr.</b-form-radio
                        >
                        <b-form-radio value="female" class="pc-4"
                          >Mrs.</b-form-radio
                        >
                        <b-form-radio value="other" class="pc-4"
                          >Mx.</b-form-radio
                        >
                      </b-form-radio-group>
                    </b-form-group>

                    <small
                      class="invalid-feedback mt-1"
                      v-if="$v.operator.contactPerson.gender.$error"
                      >Select</small
                    >
                  </div>
                  <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                    <base-input
                      v-model.trim="$v.operator.contactPerson.email.$model"
                      id="operator_email"
                      name="operator_email"
                      label="Supplier Email "
                      placeholder="example@email.com"
                      markrequired
                      :error="
                        !$v.operator.contactPerson.email.email ||
                        $v.operator.contactPerson.email.$error
                          ? `Enter a valid email`
                          : ''
                      "
                    />
                  </div>

                  <div
                    class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 inputphone form-group"
                  >
                    <label
                      class="title-label"
                      v-bind:class="{
                        'is-invalid': $v.phoneNumbers.contactNumber.$error
                      }"
                      ><span class="markrequired">*</span>Contact Number</label
                    >
                    <vue-tel-input
                      v-model="contactNumber"
                      key="OperatorPhone"
                      inputId="operatorPhone"
                      name="operatorPhone"
                      required
                      mode="international"
                      inputClasses="input no-label no-err"
                      :dynamicPlaceholder="true"
                      :disabledFetchingCountry="true"
                      :validCharactersOnly="true"
                      :wrapperClasses="[
                        $v.phoneNumbers.contactNumber.$error
                          ? 'is-invalid'
                          : '',
                        'mb-0'
                      ]"
                      @input="validateContactNumber"
                    ></vue-tel-input>
                    <small
                      class="invalid-feedback"
                      v-if="$v.phoneNumbers.contactNumber.$error"
                      >Enter a valid Phone Number.</small
                    >
                  </div>

                  <div
                    class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 inputphone form-group"
                  >
                    <label class="title-label">Optional Phone</label>
                    <vue-tel-input
                      v-model="optionalContactNumber"
                      key="optionalPhone"
                      inputId="optionalPhone"
                      name="optionalPhone"
                      required
                      mode="international"
                      inputClasses="input"
                      :dynamicPlaceholder="true"
                      :disabledFetchingCountry="true"
                      :validCharactersOnly="true"
                      :wrapperClasses="[
                        $v.phoneNumbers.optionalContactNumber.$error
                          ? 'is-invalid'
                          : '',
                        'mb-0'
                      ]"
                      @validate="validateOptionalContactNumber"
                    ></vue-tel-input>
                    <small
                      class="invalid-feedback"
                      v-if="$v.phoneNumbers.optionalContactNumber.$error"
                      >Enter a valid phone</small
                    >
                  </div>
                  <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                    <base-input
                      v-model="$v.operator.businessDetails.website.$model"
                      id="Web"
                      name="Web"
                      label="Website "
                      placeholder="www.rhomtrip.com"
                      :error="
                        $v.operator.businessDetails.website.$error
                          ? `Invalid Website: must use either http or https`
                          : ''
                      "
                    />
                  </div>

                  <div
                    class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 switch-md mb-2"
                  >
                    <label for="driver_notifications" class="title-label ml-0">
                      Driver notifications
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <span>
                          Activate this if the supplier should receive
                          notifications requesting driver information
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </label>
                    <base-switch
                      v-model="operator.notifications.requestDriver"
                      class="mt-2"
                    ></base-switch>
                  </div>
                </div>

                <div class="row" v-if="mode === 'view'">
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Full Name</span>
                      <span class="content-block"
                        >{{ operator.contactPerson.firstName }}
                        {{ operator.contactPerson.lastName }}</span
                      >
                    </div>
                  </div>

                  <div
                    class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12"
                    v-if="operator.gender"
                  >
                    <div class="data-block">
                      <span class="title-block">Gender</span>
                      <span class="content-block">{{
                        formatGender(operator.gender)
                      }}</span>
                    </div>
                  </div>

                  <div class="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Supplier Email</span>
                      <span class="content-block">
                        <a
                          :href="
                            `https://mail.google.com/mail/?view=cm&fs=1&to=${operator.contactPerson.email}`
                          "
                          target="_blank"
                          >{{ operator.contactPerson.email }}</a
                        >
                        <el-tooltip
                          content="Copy"
                          placement="bottom"
                          v-if="operator.contactPerson.email"
                        >
                          <span
                            class="curp ml-2"
                            v-clipboard:copy="operator.contactPerson.email"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onErrorCopy"
                          >
                            <i class="flaticon-copy link ml-0"></i></span
                        ></el-tooltip>
                      </span>
                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12">
                    <div class="data-block">
                      <span class="title-block">Contact Number</span>
                      <span class="content-block">
                        <a :href="`tel:${contactNumber}`">{{
                          contactNumber
                        }}</a>
                        <el-tooltip
                          content="Copy"
                          placement="bottom"
                          v-if="contactNumber"
                        >
                          <span
                            class="curp ml-2"
                            v-clipboard:copy="contactNumber"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onErrorCopy"
                          >
                            <i class="flaticon-copy link ml-0"></i></span
                        ></el-tooltip>
                      </span>
                    </div>
                  </div>

                  <div
                    class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12"
                    v-if="optionalContactNumber"
                  >
                    <div class="data-block">
                      <span class="title-block">Optional Phone</span>
                      <span class="content-block">
                        <a :href="`tel:${optionalContactNumber}`">{{
                          optionalContactNumber
                        }}</a>
                        <el-tooltip content="Copy" placement="bottom">
                          <span
                            class="curp ml-2"
                            v-clipboard:copy="optionalContactNumber"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onErrorCopy"
                          >
                            <i class="flaticon-copy link ml-0"></i></span
                        ></el-tooltip>
                      </span>
                    </div>
                  </div>
                  <div
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="operator.businessDetails.website"
                  >
                    <div class="data-block">
                      <span class="title-block">Website</span>
                      <span class="content-block">
                        <a
                          :href="operator.businessDetails.website"
                          target="_blank"
                          >{{ operator.businessDetails.website }}</a
                        >
                        <el-tooltip content="Copy" placement="bottom">
                          <span
                            class="curp ml-2"
                            v-clipboard:copy="operator.businessDetails.website"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onErrorCopy"
                          >
                            <i class="flaticon-copy link ml-0"></i></span
                        ></el-tooltip>
                      </span>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12">
                    <div class="data-block">
                      <span class="title-block">Driver Notifications</span>
                      <span
                        class="content-block"
                        v-if="operator.notifications.requestDriver"
                        >Active</span
                      >
                      <span class="content-block" v-else>Inactive</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card  ">
                <h2 class="subtitle">Account Info</h2>

                <div class="row mt-2" v-if="mode === 'edit'">
                  <div class="col-xl-12">
                    <div class="row">
                      <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                        <base-input
                          label="Account Email"
                          placeholder="Email Address"
                          id="operator_email_account"
                          name="operator_email_account"
                          maxlength="100"
                          format="lowercase"
                          autocomplete="off"
                          v-model.trim="$v.operator.authentication.email.$model"
                          markrequired
                          :error="
                            getEmailValidationMessage(
                              $v.operator.authentication.email
                            )
                          "
                        />
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12"
                      ></div>

                      <div
                        class="col-xl-4 col-lg-3 col-md-3 col-sm-6 col-12"
                      ></div>

                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                        <base-input
                          v-model="$v.operator.authentication.password.$model"
                          label="Password"
                          placeholder="Password"
                          name="password"
                          id="password"
                          :type="inputType"
                          autocomplete="new-password"
                          maxlength="20"
                          tabindex="15"
                          class="input-append mb-0"
                          markrequired
                          :tooltip="true"
                          titleTooltip='<i class="flaticon-lock mr-2"></i><strong>Strong Password</strong>'
                          contentTooltip='<ul class="ul-pop">
                                  <li>Enter from 8 characters</li>
                                  <li>1 Uppercase Letter</li>
                                  <li>1 Lowercase Letter</li>
                                  <li>1 Number</li>
                                  <li>1 Special Character (Ex. @ # $ %)</li>
                                </ul>'
                          v-bind:class="{
                            'is-invalid':
                              $v.operator.authentication.password.$error
                          }"
                          ><template slot="append">
                            <span @click="seePassword()" class="icon-button"
                              ><i
                                v-bind:class="{
                                  'flaticon-view-1': inputType == 'password',
                                  'flaticon-hidden': inputType == 'text'
                                }"
                              ></i
                            ></span>
                          </template>
                        </base-input>
                        <small
                          class="invalid-feedback mt--1"
                          v-if="$v.operator.authentication.password.$error"
                          >{{
                            validatePassword(
                              $v.operator.authentication.password
                            )
                          }}</small
                        >
                        <small
                          class="valid-feedback mt-0"
                          v-if="
                            $v.operator.authentication.password
                              .strongPassword &&
                              $v.operator.authentication.password.$model
                          "
                          >Strong Password</small
                        >
                      </div>

                      <div
                        class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mt-sm-0 mt-4"
                      >
                        <base-input
                          v-model.trim="$v.repeatPassword.$model"
                          label="Confirm Password"
                          placeholder="Confirm Password "
                          type="password"
                          id="confirm_password"
                          name="confirm_password"
                          maxlength="20"
                          tabindex="16"
                          :error="
                            !$v.repeatPassword.sameAsPassword ||
                            $v.repeatPassword.$error
                              ? `Passwords must be identical`
                              : ''
                          "
                        />
                      </div>

                      <div
                        class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12  form-group alinmov1"
                      >
                        <base-button
                          type="outline-secondary"
                          class="min-button"
                          @click="autogeneratePass()"
                        >
                          <i class="flaticon-bold-lock"></i>Generate Password
                        </base-button>

                        <base-button
                          type="outline-secondary"
                          class="min-button"
                          v-clipboard:copy="
                            $v.operator.authentication.password.$model
                          "
                          v-clipboard:success="onCopy"
                          v-clipboard:error="onErrorCopy"
                          v-if="$v.operator.authentication.password.$model"
                        >
                          <i class="flaticon-copy"></i>Copy Password
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="mode === 'view'">
                  <div class="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Account Email</span>
                      <span class="content-block">
                        <a
                          :href="
                            `https://mail.google.com/mail/?view=cm&fs=1&to=${operator.authentication.email}`
                          "
                          target="_blank"
                          >{{ operator.authentication.email }}</a
                        >
                        <el-tooltip content="Copy" placement="bottom">
                          <span
                            class="curp ml-2"
                            v-clipboard:copy="operator.authentication.email"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onErrorCopy"
                          >
                            <i class="flaticon-copy link ml-0"></i></span
                        ></el-tooltip>
                      </span>
                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Register Source</span>
                      <span class="content-block">{{ source }}</span>
                    </div>
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Register Date/Time</span>
                      <span class="content-block">{{ createdAt }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card ">
                <h2 class="subtitle">Address</h2>

                <div class="row mt-2" v-if="mode === 'edit'">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-model="$v.operator.address.street.$model"
                      label="Street address, apartment, suite, etc."
                      placeholder="Street address, apartment, suite, etc"
                      id="operator_street"
                      name="operator_street"
                      maxlength="200"
                      tabindex="9"
                      format="capitalize"
                      :error="
                        !$v.operator.address.street.minLength ||
                        $v.operator.address.street.$error
                          ? `Enter from ${$v.operator.address.street.$params.minLength.min} to ${$v.operator.address.street.$params.maxLength.max} characters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-model="$v.operator.address.city.$model"
                      label="City"
                      placeholder="City"
                      id="operator_city"
                      name="operator_city"
                      maxlength="45"
                      tabindex="10"
                      format="capitalize"
                      markrequired
                      :error="
                        !$v.operator.address.city.minLength ||
                        $v.operator.address.city.$error
                          ? `Enter from ${$v.operator.address.city.$params.minLength.min} to ${$v.operator.address.city.$params.maxLength.max} letters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-model="$v.operator.address.state.$model"
                      label="State/Province/Region"
                      placeholder="State/Province/Region"
                      id="operator_state"
                      name="operator_state"
                      maxlength="45"
                      tabindex="11"
                      format="capitalize"
                      markrequired
                      :error="
                        !$v.operator.address.state.minLength ||
                        $v.operator.address.state.$error
                          ? `Enter from ${$v.operator.address.state.$params.minLength.min} to ${$v.operator.address.state.$params.maxLength.max} letters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-model.trim="$v.operator.address.zipCode.$model"
                      label="Zip/Postal Code"
                      placeholder="Zip/Postal Code"
                      id="operator_zipcode"
                      name="operator_zipcode"
                      maxlength="45"
                      tabindex="12"
                      :error="
                        !$v.operator.address.zipCode.minLength ||
                        $v.operator.address.zipCode.$error
                          ? `Enter from ${$v.operator.address.zipCode.$params.minLength.min} to ${$v.operator.address.zipCode.$params.maxLength.max} characters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-12">
                    <WSelect
                      v-bind:class="{
                        'invalid-feedback': $v.operator.address.country.$error
                      }"
                      v-model="$v.operator.address.country.$model"
                      label="Country"
                      placeholder="Enter a Country"
                      id="operator_country"
                      name="operator_country"
                      class="mb-0"
                      filterable
                      remote
                      reserve-keyword
                      :remote-method="searchCountry"
                      :loading="loading"
                      clearable
                      markrequired
                    >
                      <el-option
                        v-for="country in countriesOptions"
                        :value="country.name"
                        :label="country.name"
                        :key="country.name"
                      ></el-option>
                    </WSelect>
                    <small
                      class="invalid-feedback mt-0"
                      v-if="$v.operator.address.country.$error"
                      >Enter a Country</small
                    >
                  </div>
                  <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
                    <base-input
                      v-model.trim="$v.operator.address.otherStreet.$model"
                      id="operator_OtherAddress"
                      name="operator_OtherAddress"
                      label="Other Address"
                      placeholder="Other Address"
                      :error="
                        !$v.operator.address.otherStreet.minLength ||
                        $v.operator.address.otherStreet.error
                          ? `Enter from ${$v.operator.address.otherStreet.$params.minLength.min} to ${$v.operator.address.otherStreet.$params.maxLength.max} characters`
                          : ''
                      "
                    />
                  </div>
                </div>

                <div class="row" v-if="mode === 'view'">
                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                    v-if="operator.address.street"
                  >
                    <div class="data-block">
                      <span class="title-block"
                        >Street address, apartment, suite, etc.</span
                      >
                      <span class="content-block">{{
                        operator.address.street
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                    v-if="operator.address.city"
                  >
                    <div class="data-block">
                      <span class="title-block">City</span>
                      <span class="content-block capitalize">{{
                        operator.address.city
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                    v-if="operator.address.state"
                  >
                    <div class="data-block">
                      <span class="title-block">State/Province/Region</span>
                      <span class="content-block">{{
                        operator.address.state
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                    v-if="operator.address.zipCode"
                  >
                    <div class="data-block">
                      <span class="title-block">Zip/Postal Code</span>
                      <span class="content-block">{{
                        operator.address.zipCode
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                    v-if="operator.address.country"
                  >
                    <div class="data-block">
                      <span class="title-block">Country</span>
                      <span class="content-block">{{
                        operator.address.country
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                    v-if="operator.address.otherStreet"
                  >
                    <div class="data-block">
                      <span class="title-block">Other Address</span>
                      <span class="content-block">{{
                        operator.address.otherStreet
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>

            <tab-pane
              class="tabs-home-content"
              id="paymentInfo"
              title="Payment Info"
              ref="paymentInfo"
              :disabledTab="!operator.affiliate"
              msgDisabled="Option unavailable: Supplier isn't affiliated to our network"
            >
              <div class="card">
                <div>
                  <div class="row mb-2">
                    <div class="col-6 align-self-center">
                      <h2 class="subtitle mb-0">
                        Payment Methods
                      </h2>
                    </div>
                    <div class="col-6 alinmov2 align-self-center">
                      <base-button
                        v-if="canUserCreate"
                        type="outline-secondary"
                        class="min-button"
                        @click="createPaymentMethod()"
                      >
                        <i class="flaticon-plus"></i> Add new
                      </base-button>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 mb-4" v-if="paymentMethods.length === 0">
                      <base-alert type="warning" class="mb-1 info-min">
                        <i class="flaticon-warning mr-1"></i> There are no
                        payment methods here
                      </base-alert>
                    </div>

                    <div class="col-12" v-else>
                      <div
                        v-for="(option, index) in paymentMethods"
                        :key="index"
                        class="card card-shadow pb-2"
                      >
                        <div class="row">
                          <div
                            class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-12 align-self-center alinmov6"
                          >
                            <div
                              v-if="option.type === 'bank_account'"
                              class="mb-3"
                            >
                              <img
                                src="~rhomtrip_assets/src/img/icons/bank.png"
                                alt="bank"
                                class="icon-payment"
                              /><span class="d-block">
                                <strong>
                                  {{
                                    formatTransferType(option.type_transfer)
                                  }}</strong
                                ></span
                              >
                            </div>

                            <div v-else>
                              <img
                                src="~rhomtrip_assets/src/img/icons/paypal.png"
                                alt="bank"
                                class="icon-payment mb-3"
                              />
                            </div>
                          </div>

                          <div
                            class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-12 align-self-center alinmov4"
                          >
                            <div class="data-block">
                              <h2 class="subtitle mb-0 d-md-inline d-sm-block">
                                {{ formatPaymentMethodType(option.type) }}
                                <span
                                  class="badge-status badge-default ml-2"
                                  v-if="option.default"
                                  >Default</span
                                >
                              </h2>

                              <div v-if="option.type === 'bank_account'">
                                <span class="content-block"
                                  ><strong
                                    >Account Holder / Business Name:</strong
                                  >
                                  {{ option.name_account }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.name_account"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>

                                <span class="content-block"
                                  ><strong>Type Transfer:</strong>
                                  {{ formatTransferType(option.type_transfer) }}
                                </span>

                                <span
                                  class="content-block"
                                  v-if="
                                    option.type_transfer === 'ach' ||
                                      option.type_transfer === 'wire'
                                  "
                                  ><strong>Account Type:</strong>
                                  {{ formatAccountType(option.account_type) }}
                                </span>

                                <span
                                  class="content-block"
                                  v-if="
                                    option.type_transfer === 'ach' ||
                                      option.type_transfer === 'wire'
                                  "
                                  ><strong
                                    v-if="option.type_transfer === 'ach'"
                                  >
                                    ACH Routing Number:</strong
                                  >
                                  <strong
                                    v-else-if="option.type_transfer === 'wire'"
                                  >
                                    Fedwire Routing Number:</strong
                                  >
                                  {{ option.routing_number }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.routing_number"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span
                                  ></el-tooltip>
                                </span>

                                <span
                                  class="content-block"
                                  v-if="option.type_transfer === 'swift'"
                                  ><strong>SWIFT Code / BIC Code:</strong>
                                  {{ option.swift_code }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.swift_code"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>

                                <span
                                  class="content-block"
                                  v-if="option.type_transfer === 'transfer_gbp'"
                                  ><strong>UK Sort Code:</strong>
                                  {{ option.uk_sort_code }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.uk_sort_code"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>

                                <span class="content-block">
                                  <strong
                                    v-if="
                                      option.type_transfer === 'transfer_eur'
                                    "
                                    >IBAN:</strong
                                  >
                                  <strong
                                    v-else-if="option.type_transfer === 'swift'"
                                    >IBAN / Account Number:</strong
                                  >
                                  <strong v-else>Account Number:</strong>

                                  {{ option.account_number }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.iban"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>

                                <span class="content-block"
                                  ><strong>Recipient Address:</strong>
                                  {{
                                    getAddreess(
                                      option.address,
                                      option.city,
                                      option.post_code,
                                      option.country
                                    )
                                  }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="
                                        getAddreess(
                                          option.address,
                                          option.city,
                                          option.post_code,
                                          option.country
                                        )
                                      "
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>
                              </div>
                              <div v-else>
                                <span class="content-block"
                                  ><strong>Account:</strong> {{ option.email }}

                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="option.email"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i
                                        class="flaticon-copy link ml-0"
                                      ></i></span></el-tooltip
                                ></span>
                              </div>
                            </div>
                          </div>

                          <div
                            class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 align-self-center mb-3 alinmov6"
                          >
                            <el-tooltip content="Edit" placement="bottom">
                              <span
                                class="icon-action ml-2"
                                @click="editPaymentMethodByIndex(option, index)"
                              >
                                <i class="flaticon-pencil text-primary"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip
                              content="Mark by default"
                              placement="bottom"
                            >
                              <span
                                class="icon-action ml-2"
                                @click="makePaymentMethodAsDefault(index)"
                                v-if="!option.default"
                              >
                                <i class="flaticon-bold-button text-new"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip content="Delete" placement="bottom">
                              <span
                                class="icon-action ml-2"
                                @click="deletePaymentMethod(index)"
                              >
                                <i class="flaticon-delete text-danger"></i>
                              </span>
                            </el-tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ManagePaymentMethod
                :show="showPaymentMethodModal"
                :paymentMethod="paymentMethod"
                :type="paymentMethodType"
                @addPaymentMethod="addPaymentMethod"
                @editPaymentMethod="editPaymentMethod"
                @closeModal="closePaymentMethodModal"
              />
            </tab-pane>

            <tab-pane
              class="tabs-home-content"
              id="Destinations"
              title="Destinations"
              ref="Destinations"
              :disabledTab="!operator.affiliate"
              msgDisabled="Option unavailable: Supplier isn't affiliated to our network"
            >
              <div>
                <Destinations :supplierId="operatorId" />
              </div>
            </tab-pane>

            <tab-pane
              class="tabs-home-content"
              id="Metrics"
              title="Metrics"
              ref="Metrics"
            >
              <Reservations :supplierId="operatorId" />
            </tab-pane>

            <tab-pane
              class="tabs-home-content"
              id="settings"
              title="Settings"
              ref="settings"
              :disabledTab="!operator.affiliate"
              msgDisabled="Option unavailable: Supplier isn't affiliated to our network"
            >
              <div class="card">
                <h2 class="subtitle">Default Settings</h2>

                <div class="row mt-2" v-if="mode === 'edit'">
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                    <WSelect
                      label="Measurement Unit"
                      placeholder="Measurement Unit"
                      v-model="operator.settings.measurementUnit"
                      id="measurement"
                      name="measurement"
                      markrequired
                    >
                      <el-option
                        v-for="option in unitDistances"
                        :value="option.value"
                        :label="option.label"
                        :key="option.label"
                      ></el-option>
                    </WSelect>
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                    <WSelect
                      label="Distance for rate calculation"
                      placeholder="Distance"
                      id="distance_max"
                      name="distance_max"
                      v-model="operator.settings.maximumDistance"
                      input-group-classes="input-group-merge"
                      :tooltip="true"
                      markrequired
                      contentTooltip="For rides less than the Kilometers in rate
                            calculation, RhomTrip will calculate Area + extra km
                            for rides greater than the Kilometers in rate
                            calculation, RhomTrip will calculate Base price +
                            extra km"
                    >
                      <el-option
                        v-for="option in areaRadius"
                        :value="option.value"
                        :label="option.label"
                        :key="option.label"
                      ></el-option>
                      <template slot="suffix">{{
                        operator.settings.measurementUnit
                      }}</template>
                    </WSelect>
                  </div>

                  <div
                    class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 form-group"
                  >
                    <label for="title" class="title-label"
                      ><span class="markrequired">*</span>Taxes</label
                    >
                    <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                      <b-form-radio-group
                        v-model="operator.settings.taxes.type"
                        :aria-describedby="ariaDescribedby"
                        id="settings_taxes_type"
                        name="settings_taxes_type"
                        buttons
                        button-variant="outline-neutral pc-1"
                        size="md"
                      >
                        <b-form-radio value="tax">TAX</b-form-radio>

                        <b-form-radio value="vat">VAT</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
                    <BaseNumberInput
                      :label="
                        `Value ${getTaxesFormat(operator.settings.taxes.type)}`
                      "
                      placeholder="Value"
                      id="setting_taxes_value"
                      name="setting_taxes_value"
                      class="input-append"
                      markrequired
                      v-model.number="$v.operator.settings.taxes.value.$model"
                      :error="
                        $v.operator.settings.$error ||
                        !$v.operator.settings.taxes.value.between
                          ? `Must be between ${$v.operator.settings.taxes.value.$params.between.min}% and Maximum ${$v.operator.settings.taxes.value.$params.between.max}%`
                          : ''
                      "
                    >
                      <template slot="append">%</template>
                    </BaseNumberInput>
                  </div>
                </div>

                <div class="row" v-if="mode === 'view'">
                  <div class="col-xl-12">
                    <div class="row">
                      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Measurement Unit</span>
                          <span class="content-block">{{
                            getMeasurementUnitFormat(
                              operator.settings.measurementUnit
                            )
                          }}</span>
                        </div>
                      </div>

                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block"
                            >Distance for rate calculation</span
                          >
                          <span class="content-block capitalize"
                            >{{ operator.settings.maximumDistance }}
                            {{ operator.settings.measurementUnit }}</span
                          >
                        </div>
                      </div>

                      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Taxes</span>
                          <span class="content-block">{{
                            getTaxesFormat(operator.settings.taxes.type)
                          }}</span>
                        </div>
                      </div>

                      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block"
                            >Value
                            {{
                              getTaxesFormat(operator.settings.taxes.type)
                            }}</span
                          >
                          <span class="content-block"
                            >{{ operator.settings.taxes.value }}%</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  email,
  sameAs,
  numeric,
  decimal,
  between,
  url
} from "vuelidate/lib/validators";
import { helpers } from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import { mapGetters, mapMutations } from "vuex";
import Swal from "sweetalert2";
import { VueTelInput } from "vue-tel-input";
import { OperatorsAPI, AuthAPI } from "../../../core/api";
import WSelect from "@/components/Select";
import lodash from "lodash";
import ManagePaymentMethod from "../components/PaymentMethods.vue";
import Destinations from "../components/destinations/Destinations.vue";
import Reservations from "../components/Reservations.vue";
import generator from "generate-password";
import moment from "moment";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../helpers/commons.helpers";
import { FileService } from "../../../core/services";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "EditOperator",
  data() {
    return {
      operator: {
        businessDetails: {
          name: "",
          legalName: "",
          vatNumber: "",
          licenseNumber: "",
          website: "",
          image: ""
        },
        contactPerson: {
          firstName: "",
          lastName: "",
          fullName: "",
          gender: "",
          phoneNumbers: [],
          email: ""
        },
        address: {
          country: "",
          city: "",
          state: "",
          zipCode: "",
          street: "",
          otherStreet: ""
        },
        type: "supplier",
        authentication: {
          email: "",
          password: "",
          accountStatus: "ACTIVE",
          verified: false
        },
        preferredContactMethod: "phoneNumber",
        paymentMethods: [],
        affiliate: false,
        notes: "",
        currency: "USD",
        notifications: {
          requestDriver: true
        },
        settings: {
          maximumDistance: 150,
          measurementUnit: "km",
          taxes: {
            type: "vat",
            value: 0
          }
        },
        serviceType: "TRANSFERS" // o "PRODUCTS"
      },
      repeatPassword: "",
      loading: false,
      options: [],
      contactNumber: "",
      optionalContactNumber: "",
      operatorCopy: {},
      saved: false,
      inputType: "password",
      lastEmail: "",
      operatorId: "",
      picture: "",
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      tabActive: "Overview",
      countriesOptions: [],
      coins: [
        { code: "USD", symbol: "$", label: "US Dollar" },
        { code: "EUR", symbol: "€", label: "Euro" },
        { code: "GBP", symbol: "£", label: "British Pound" },
        { code: "CHF", symbol: "₣", label: "Swiss Franc" },
        { code: "DKK", symbol: "kr", label: "Denmark Krone" },
        { code: "SEK", symbol: "kr", label: "Swedish Krona" },
        { code: "NOK", symbol: "kr", label: "Norwegian Krone" },
        { code: "ISK", symbol: "kr", label: "Icelandic Króna" },
        { code: "AED", symbol: "د.إ", label: "United Arab Emirates Dirham" }
      ],
      mode: "view",
      source: "Rhomtrip",
      createdAt: "",
      paymentMethods: [],
      showPaymentMethodModal: false,
      paymentMethod: null,
      paymentMethodIndex: 0,
      paymentMethodType: "create",
      phoneNumbers: {
        contactNumber: "",
        optionalContactNumber: ""
      },
      operatorStatus: false,
      operatorAffiliate: false,
      areaRadius: [
        { value: 50, label: "50" },
        { value: 100, label: "100" },
        { value: 150, label: "150" },
        { value: 200, label: "200" },
        { value: 250, label: "250" },
        { value: 300, label: "300" },
        { value: 350, label: "350" },
        { value: 400, label: "400" },
        { value: 450, label: "450" },
        { value: 500, label: "500" },
        { value: 550, label: "550" },
        { value: 600, label: "600" }
      ],
      unitDistances: [
        { value: "km", label: "Metric | Km" },
        { value: "miles", label: "Standard | Miles" }
      ],
      serviceType: false
    };
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Suppliers",
        to: "/suppliers"
      },

      {
        text: "Supplier Profile",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.operatorId = this.$route.params.id;
    await this.getOperator(this.operatorId);
  },
  methods: {
    validateContactNumber(value, payload) {
      let result = payload;
      if (result.isValid) {
        this.phoneNumbers.contactNumber = result.number.e164;
      } else {
        this.phoneNumbers.contactNumber = null;
      }
    },
    validateOptionalContactNumber(payload) {
      let result = payload;
      if (result.isValid) {
        this.phoneNumbers.optionalContactNumber = result.number.e164;
      }
    },
    async getOperator(operatorId) {
      try {
        this.setLoad(true);
        let { data } = await OperatorsAPI.getOperatorById(
          operatorId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          let operator = data.data;
          this.operator.businessDetails.name = operator.businessDetails.name;
          this.operator.businessDetails.legalName =
            operator.businessDetails.legalName;

          this.operator.businessDetails.vatNumber =
            operator.businessDetails.vatNumber;
          this.operator.businessDetails.licenseNumber =
            operator.businessDetails.licenseNumber;
          this.operator.businessDetails.website =
            operator.businessDetails.website;

          this.operator.contactPerson.email = operator.contactPerson.email;
          this.operator.businessDetails.image = operator.businessDetails.image;
          this.picture = operator.businessDetails.image;

          this.operator.authentication.accountStatus =
            operator.authentication.accountStatus;

          this.operatorStatus =
            this.operator.authentication.accountStatus === "ACTIVE";

          this.operator.serviceType = operator.serviceType;
          this.serviceType = this.operator.serviceType === "PRODUCTS";

          this.operator.notifications.requestDriver =
            operator.notifications.requestDriver;

          this.operator.address.street = operator.address.street;
          this.operator.address.country = operator.address.country;
          this.operator.address.state = operator.address.state;
          this.operator.address.city = operator.address.city;
          this.operator.address.zipCode = operator.address.zipCode;
          this.operator.address.otherStreet = operator.address.otherStreet;

          this.operator.contactPerson.phoneNumbers =
            operator.contactPerson.phoneNumbers;

          this.contactNumber = this.getContactNumber(
            true,
            operator.contactPerson.phoneNumbers
          );
          this.optionalContactNumber = this.getContactNumber(
            false,
            operator.contactPerson.phoneNumbers
          );
          this.operator.businessDetails.website =
            operator.businessDetails.website;
          this.phoneNumbers.contactNumber = this.contactNumber;
          this.phoneNumbers.optionalContactNumber = this.optionalContactNumber;

          this.operator.affiliate = operator.affiliate;
          this.operatorAffiliate = this.operator.affiliate;

          this.operator.authentication.email = operator.authentication.email;
          this.operator.contactPerson.firstName =
            operator.contactPerson.firstName;
          this.operator.contactPerson.lastName =
            operator.contactPerson.lastName;
          this.operator.contactPerson.fullName =
            operator.contactPerson.lastName;

          this.operator.contactPerson.gender = operator.contactPerson.gender;

          this.operator.authentication.email = operator.authentication.email;
          this.$v.operator.authentication.email.$model =
            operator.authentication.email;

          this.operator.authentication.verified =
            operator.authentication.verified;

          this.operator.notes = operator.notes;

          this.operator.currency = operator.currency;

          this.operator.paymentMethods = operator.paymentMethods;
          this.paymentMethods = operator.paymentMethods;

          this.operator.settings.maximumDistance =
            operator.settings.maximumDistance;
          this.operator.settings.measurementUnit =
            operator.settings.measurementUnit;
          this.operator.settings.taxes.type = operator.settings.taxes.type;
          this.operator.settings.taxes.value = operator.settings.taxes.value;

          this.lastEmail = this.operator.authentication.email;
          this.createdAt = moment(operator.created_at).format(
            "DD MMM. YYYY - hh:mm A"
          );
          this.operatorCopy = lodash.cloneDeep(this.operator);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async saveOperator(route = null) {
      if (
        !this.$v.operator.$invalid &&
        !this.$v.phoneNumbers.$invalid &&
        !this.$v.repeatPassword.$invalid
      ) {
        let operator = lodash.cloneDeep(this.operator);
        operator.contactPerson.phoneNumbers = this.populatePhoneNumbers(
          this.phoneNumbers.contactNumber,
          this.phoneNumbers.optionalContactNumber
        );
        await this.updateOperator(this.operatorId, operator, route);
      } else {
        this.$v.repeatPassword.$touch();
        this.$v.operator.$touch();
        this.$notify({
          type: "warning",
          title: "Warning",
          message: "Please complete the required attributes"
        });
      }
    },
    async updateOperator(operatorId, operator, route = null) {
      try {
        this.setLoad(true);
        let { data } = await OperatorsAPI.updateOperatorById(
          operatorId,
          operator,
          this.sesion.token
        );
        this.setLoad(false);
        this.saved = true;
        if (data.data !== null) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Supplier has been Updated",
            icon: "flaticon-check-3"
          });
          this.mode = "view";
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.saved = true;
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error updating the Supplier, please try again"
        );
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    validatePassword(password) {
      if (password.$error) {
        if (!password.$minLength) {
          return `Password must have at least ${password.$params.minLength.min} letters.`;
        } else if (password.$required && password.$model.length < 1) {
          return `Password is required`;
        } else {
          return "Invalid password";
        }
      } else {
        return "";
      }
    },
    autogeneratePass() {
      var password = generator.generate({
        length: 8,
        numbers: true,
        symbols: true,
        lowercase: true,
        uppercase: true,
        strict: true
      });
      this.operator.authentication.password = password;
      this.repeatPassword = password;
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The password has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The password could not be copied",
        icon: "flaticon-remove"
      });
    },
    seePassword() {
      this.inputType = this.inputType == "password" ? "text" : "password";
    },
    isInSupplierModule(modules = []) {
      if (!(modules.indexOf("suppliers") > -1)) {
        this.setSupplierSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    async detectChanges(to, from, next) {
      let isEqual = lodash.isEqual(this.operator, this.operatorCopy);
      if (!isEqual && !this.saved && this.canUserUpdate) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The Supplier has been modified,<br> do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveOperator(to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    readFile: async function(event) {
      const [file] = event.target.files;
      if (file.size > 500 * 500) {
        event.preventDefault();
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
          icon: "flaticon-remove"
        });
        this.clearfile();
      } else {
        let fileData = FileService.generateResourceData(
          "/users/avatars",
          file.name
        );
        let queryString = FileService.buildQueryString(fileData);
        let urlFile = await FileService.uploadResource(file, queryString);
        if (urlFile) {
          this.operator.businessDetails.image = urlFile;
          this.picture = urlFile;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
            icon: "flaticon-remove"
          });
        }
      }
    },
    clearfile() {
      this.operator.businessDetails.image = "";
      this.picture = "";
    },
    searchCountry(value) {
      if (value !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.countriesOptions = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
          });
        }, 100);
      } else {
        this.countriesOptions = [];
      }
    },
    async sendEmailToConfirmAccount(operatorId) {
      let { value } = await Swal.fire({
        title: "Account Confirmation Email",
        html:
          "Are you sure you want to <strong>Send</strong> an account confirmation email?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.sendEmailToConfirmAccountById(operatorId);
      }
    },
    async sendEmailToConfirmAccountById(operatorId) {
      try {
        this.setLoad(true);
        let { data } = await OperatorsAPI.sendEmailToConfirmAccountById(
          operatorId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The email has been send",
            icon: "flaticon-remove"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The email can't be send!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async sendEmailToRecoverPassword(operatorId) {
      let { value } = await Swal.fire({
        title: "Password Recovery Email",
        html:
          "Are you sure you want to <strong>send</strong> the password recovery email?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.sendEmailToRecoverPasswordById(operatorId);
      }
    },
    async sendEmailToRecoverPasswordById(operatorId) {
      try {
        this.setLoad(true);
        let { data } = await OperatorsAPI.sendEmailToRecoverPasswordById(
          operatorId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The email has been sent",
            icon: "flaticon-remove"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The email can't be send!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    getCurrencyName(currencyCode) {
      if (currencyCode === "USD") {
        return "US Dollar";
      } else if (currencyCode === "EUR") {
        return "Euro";
      } else if (currencyCode === "GBP") {
        return "British Pound";
      } else if (currencyCode === "CHF") {
        return "Swiss Franc";
      } else if (currencyCode === "DKK") {
        return "Denmark Krone";
      } else if (currencyCode === "SEK") {
        return "Swedish Krona";
      } else if (currencyCode === "NOK") {
        return "Norwegian Krone";
      } else if (currencyCode === "ISK") {
        return "Icelandic Króna";
      } else if (currencyCode === "AED") {
        return "United Arab Emirates Dirham";
      }
    },
    openPaymentMethodModal() {
      this.showPaymentMethodModal = true;
    },
    closePaymentMethodModal() {
      this.showPaymentMethodModal = false;
      this.paymentMethodIndex = 0;
      this.paymentMethodType = "create";
      this.paymentMethod = null;
    },
    createPaymentMethod() {
      this.paymentMethodIndex = 0;
      this.paymentMethodType = "create";
      this.paymentMethod = null;
      this.openPaymentMethodModal();
    },
    async addPaymentMethod(paymentMethod) {
      if (this.paymentMethods.length === 0) {
        paymentMethod.default = true;
        this.paymentMethods.push(paymentMethod);
      } else {
        this.paymentMethods.push(paymentMethod);
      }
      await this.updatePaymentMethodByOperatorId(
        this.operatorId,
        { paymentMethods: this.paymentMethods },
        "The Payment Method has been Added"
      );
    },
    async makePaymentMethodAsDefault(index) {
      this.paymentMethods = this.paymentMethods.map(paymentMethod => {
        paymentMethod.default = false;
        return paymentMethod;
      });
      this.paymentMethods[index].default = true;
      await this.updatePaymentMethodByOperatorId(
        this.operatorId,
        { paymentMethods: this.paymentMethods },
        "The Payment Method has been Updated"
      );
      this.paymentMethods = this.moveElementToFirst(this.paymentMethods);
    },
    async deletePaymentMethod(index) {
      let { value } = await Swal.fire({
        title: "Delete Payment Method",
        text: "Are you sure do you want to delete this Payment Method?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        this.paymentMethods.splice(index, 1);
        if (this.paymentMethods.length === 1) {
          this.paymentMethods[0].default = true;
        }
        await this.updatePaymentMethodByOperatorId(
          this.operatorId,
          { paymentMethods: this.paymentMethods },
          "The Payment Method has been Deleted"
        );
      }
    },
    editPaymentMethodByIndex(option, index) {
      this.paymentMethodIndex = index;
      this.paymentMethodType = "edit";
      this.paymentMethod = option;
      this.openPaymentMethodModal();
    },
    async editPaymentMethod(paymentMethod) {
      if (paymentMethod) {
        this.paymentMethods.splice(this.paymentMethodIndex, 1, paymentMethod);
      }
      await this.updatePaymentMethodByOperatorId(
        this.operatorId,
        { paymentMethods: this.paymentMethods },
        "The Payment Method has been Updated"
      );
      this.paymentMethodIndex = 0;
      this.paymentMethodType = "create";
      this.paymentMethod = null;
    },
    async updatePaymentMethodByOperatorId(
      operatorId,
      paymentMethods,
      successMessage
    ) {
      try {
        let { data } = await OperatorsAPI.updateAnyAttributeById(
          operatorId,
          paymentMethods,
          this.sesion.token
        );
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: successMessage,
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "There was an error saving the Payment Method, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "There was an error saving the Payment Method, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    populatePhoneNumbers(contactNumber, optionalContactNumber) {
      return [
        {
          number: contactNumber,
          type: "mobile",
          preferred: true
        },
        {
          number: optionalContactNumber,
          type: "mobile",
          preferred: false
        }
      ];
    },
    getContactNumber(status, phoneNumbers = []) {
      let contactNumber = phoneNumbers.find(
        phone => phone.preferred === status
      );
      if (contactNumber) {
        return contactNumber.number;
      } else {
        return "";
      }
    },
    async verifyOperatorEmail(email) {
      try {
        if (email) {
          let { data } = await AuthAPI.checkUniqueEmail(email.toLowerCase());
          if (data.status) {
            return !data.data.status;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    validateEmail(email) {
      return /^[\w+\-\.]+@[\w-]+(\.[a-zA-Z]{2,}){1,}$/.test(email);
    },
    getEmailValidationMessage(email) {
      if (email.$error) {
        if (!email.required) {
          return "Enter a valid email";
        } else if (!email.email) {
          return "Email is invalid";
        } else if (!email.customValidator) {
          return "Email is already used.";
        }
      } else {
        return "";
      }
    },
    changeOperatorStatus(changeOperatorStatus) {
      this.operator.authentication.accountStatus = changeOperatorStatus
        ? "ACTIVE"
        : "INACTIVE";
    },
    getAddreess(address, city, post_code, country) {
      return address + ", " + city + ", " + post_code + ", " + country;
    },
    formatGender(gender) {
      if (gender === "male") {
        return "Male";
      } else if (gender == "female") {
        return "Female";
      } else {
        return "Mx.";
      }
    },
    formatPaymentMethodType(type) {
      if (type === "paypal") {
        return "Paypal";
      } else {
        return "Bank Account";
      }
    },
    formatTransferType(type) {
      if (type === "ach") {
        return "ACH";
      } else if (type === "wire") {
        return "WIRE";
      } else if (type === "swift") {
        return "SWIFT";
      } else if (type === "transfer_eur") {
        return "Transfer to EUR";
      } else if (type === "transfer_gbp") {
        return "Transfer to GBP";
      }
    },
    formatAccountType(type) {
      if (type === "savings") {
        return "Savings";
      } else if (type === "checking") {
        return "Checking";
      }
    },
    changeTabActive(tabActive) {
      this.tabActive = tabActive;
    },
    changeAffiliateNetwork(value) {
      if (["Payment Info", "Destinations"].includes(this.tabActive)) {
        this.tabActive = "Overview";
      }
      this.operator.affiliate = value;
    },
    getMeasurementUnitFormat(value) {
      if (value === "km") {
        return "Metric | Km";
      } else {
        return "Standard | Miles";
      }
    },
    getTaxesFormat(value) {
      if (value === "vat") {
        return "VAT";
      } else {
        return "TAX";
      }
    },
    servicesProvided(value) {
      this.operator.serviceType = value ? "PRODUCTS" : "TRANSFERS";
    },
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setSupplierSearchCriteria"
    ])
  },
  beforeRouteLeave(to, from, next) {
    this.isInSupplierModule(to.meta.modules);
    if (!this.sigout) {
      this.detectChanges(to, from, next);
    } else {
      next();
    }
  },
  validations: {
    operator: {
      businessDetails: {
        name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45)
        },
        legalName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45)
        },
        vatNumber: {
          minLength: minLength(5),
          maxLength: maxLength(25)
        },
        licenseNumber: {
          minLength: minLength(5),
          maxLength: maxLength(25)
        },
        website: {
          url
        }
      },

      address: {
        country: {
          ValName,
          required,
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        city: {
          ValName,
          required,
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        state: {
          ValName,
          required,
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        zipCode: {
          minLength: minLength(4),
          maxLength: maxLength(10)
        },
        street: {
          minLength: minLength(5),
          maxLength: maxLength(100)
        },
        otherStreet: {
          minLength: minLength(5),
          maxLength: maxLength(100)
        }
      },
      contactPerson: {
        lastName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45),
          ValName
        },
        firstName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45),
          ValName
        },
        gender: {
          required: false
        },
        email: {
          required,
          email
        }
      },
      authentication: {
        email: {
          required,
          email,
          customValidator: async function(value) {
            if (this.validateEmail(value)) {
              if (this.lastEmail !== value) {
                return await this.verifyOperatorEmail(value);
              } else {
                return true;
              }
            } else {
              return false;
            }
          }
        },
        password: {
          minLength: minLength(8),
          strongPassword(password) {
            if (password === "") {
              return true;
            } else {
              return (
                /[a-z]/.test(password) && // checks for a-z
                /[A-Z]/.test(password) && // checks for A-Z
                /[0-9]/.test(password) && // checks for 0-9
                /\W|_/.test(password) && // checks for special char
                password.length >= 8
              );
            }
          }
        }
      },
      notes: {
        maxLength: maxLength(500)
      },
      settings: {
        taxes: {
          value: {
            required,
            numeric,
            decimal,
            between: between(0, 100)
          }
        }
      }
    },
    phoneNumbers: {
      contactNumber: {
        required,
        minLength: minLength(7),
        maxLength: maxLength(25)
      },
      optionalContactNumber: {
        minLength: minLength(7),
        maxLength: maxLength(25)
      }
    },
    repeatPassword: {
      sameAsPassword: sameAs(function() {
        return this.operator.authentication.password;
      })
    }
  },
  computed: {
    ...mapGetters(["countries", "sesion", "userRole", "sigout"]),
    canUserUpdate() {
      return isUserAuthorized("SUPPLIERS", this.userRole, "UPDATE");
    },
    canUserCreate() {
      return isUserAuthorized("SUPPLIERS", this.userRole, "CREATE");
    }
  },
  components: {
    VueTelInput,
    WSelect,
    ManagePaymentMethod: ManagePaymentMethod,
    Destinations: Destinations,
    Reservations: Reservations
  }
};
</script>
